<script setup>
import { ref, watch } from 'vue';
import { AxiosAPI } from '@/axios';
import { useMainStore } from '../../../../stores/index';
import ModalMain from './ModalMain.vue';
import ModalResponsable from './ModalResponsable.vue';
import ModalCustomRecurrence from './ModalCustomRecurrence.vue';
import ToDoList from './ToDoListCreate.vue';
import RequiredFill from '../../Modals/RequiredFill.vue';
import moment from 'moment';

const emit = defineEmits(['CreateTask']);

const Store = useMainStore();

const viewDocument = ref(null);
const modalResponsable = ref(null);
const modalCustomRecurrence = ref(null);
const RequiredFillRef = ref(null);
const todolist = ref(null);
const fileInput = ref(null);

const activityType = ref('task');

const NameTask = ref('');
const DescriptionTask = ref('');
const Users = ref([]);
const DateStart = ref('');
const month = ref('');
const week = ref('');
const day = ref('');
const place = ref('');
const placeLink = ref('');
const allDay = ref(false);
const frequency_type = ref('1');
const customRecurrenceData = ref(null);

const priority = ref({ label: 'Baixa', value: 1 });
const priorityLabels = ref([
  { label: 'Baixa', value: 1 },
  { label: 'Média', value: 2 },
  { label: 'Alta', value: 3 }
]);

const status = ref({ label: 'À iniciar', value: 1 });
const statuses = ref([
  { label: 'À iniciar', value: 1 },
  { label: 'Em andamento', value: 2 },
  { label: 'Bloqueada', value: 4 },
  { label: 'Concluída', value: 3 }
]);

const attachments = ref([]);
const tack = ref([]);
const hour = ref('');
const loading = ref(false);

const commentText = ref('');
const commentsList = ref([]);

watch(DateStart, (value) => {
  if (!value) return;
  moment.locale('pt-br');
  day.value = moment(value).format('DD');
  week.value = moment(value).format('dddd');
  month.value = moment(value).format('MMMM');
});

const openCreateTask = (value, defaultType = 'task') => {
  activityType.value = (defaultType === 'event' || defaultType === 1) ? 'event' : 'task';
  Store.responsableTask = Store.user;
  moment.locale('pt-br');
  const m = moment(value);
  const FormatedData = m.format('YYYY-MM-DD');

  DateStart.value = FormatedData;
  day.value = m.format('DD');
  week.value = m.format('dddd');
  month.value = m.format('MMMM');
  loading.value = false;

  NameTask.value = '';
  DescriptionTask.value = '';
  Users.value = [];
  place.value = '';
  placeLink.value = '';
  allDay.value = false;
  frequency_type.value = '1';
  customRecurrenceData.value = null;
  priority.value = { label: 'Baixa', value: 1 };
  status.value = { label: 'À iniciar', value: 1, severity: 'secondary' };
  attachments.value = [];
  tack.value = [];
  hour.value = '';
  commentText.value = '';
  commentsList.value = [];

  if (viewDocument.value) {
    viewDocument.value.openModal();
  }
};

const editResponsable = () => {
  if (modalResponsable.value) {
    modalResponsable.value.openModal('teste');
  }
};

const onRecurrenceChange = () => {
  if (frequency_type.value === 'custom') {
    if (modalCustomRecurrence.value) {
      modalCustomRecurrence.value.openModal(customRecurrenceData.value);
    }
  }
};

const handleSaveRecurrence = (data) => {
  customRecurrenceData.value = data;
};

const addNewChecklist = () => {
  if (todolist.value) {
    todolist.value.addList();
  }
};

const submitComment = () => {
  if (!commentText.value.trim()) return;
  commentsList.value.push({
    user: Store.user,
    text: commentText.value.trim(),
    createdAt: new Date()
  });
  commentText.value = '';
};

const addMeetLink = () => {
  placeLink.value = 'https://meet.google.com/new';
};

const CreateTask = () => {
  loading.value = true;
  if (!NameTask.value || !DateStart.value) {
    if (RequiredFillRef.value) {
      RequiredFillRef.value.openModal();
    }
    loading.value = false;
    return;
  }

  const userIds = Users.value.map(u => u.id);
  const checklist = todolist.value ? JSON.stringify(todolist.value.lists) : JSON.stringify([]);

  const formData = new FormData();
  formData.append('title', NameTask.value);
  formData.append('description', DescriptionTask.value || '');
  formData.append('recurrence_type', frequency_type.value === 'custom' ? 1 : frequency_type.value);
  formData.append('date', DateStart.value);
  formData.append('hour', allDay.value ? '00:00:00' : (hour.value || ''));
  formData.append('location', place.value || '');
  formData.append('access_link', placeLink.value || '');
  formData.append('priority', priority.value.value || priority.value);
  formData.append('responsible_id', Store.responsableTask?.id);
  formData.append('situation', status.value.value || status.value);

  if (activityType.value === 'event') {
    formData.append('is_event', '1');
  }

  userIds.forEach(uId => {
    formData.append('users[]', uId);
  });

  tack.value.forEach(file => {
    formData.append('attachments[]', file);
  });

  formData.append('checklists', checklist);

  if (commentsList.value.length > 0) {
    const commentsData = commentsList.value.map(c => c.text).join('\n');
    formData.append('comment', commentsData);
  } else if (commentText.value.trim()) {
    formData.append('comment', commentText.value.trim());
  }

  AxiosAPI.post('/api/tasks', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${Store.accessToken}`
    }
  }).then(() => {
    NameTask.value = '';
    DescriptionTask.value = '';
    Users.value = [];
    DateStart.value = '';
    hour.value = '';
    place.value = '';
    placeLink.value = '';
    priority.value = { label: 'Baixa', value: 1 };
    status.value = { label: 'À iniciar', value: 1, severity: 'secondary' };
    attachments.value = [];
    tack.value = [];
    Store.responsableTask = Store.user;
    commentsList.value = [];
    commentText.value = '';

    emit('CreateTask');
    if (viewDocument.value) {
      viewDocument.value.closeModal();
    }
  }).catch(error => {
    console.error('Erro ao criar tarefa:', error);
  }).finally(() => {
    loading.value = false;
  });
};

const addAttachment = (event) => {
  const files = Array.from(event.target.files);
  const newFiles = files.filter(file =>
    !tack.value.some(existingFile => existingFile.name === file.name)
  );

  attachments.value.push(...newFiles.map(file => ({ name: file.name })));
  tack.value.push(...newFiles);
};

const removeAttachment = (index) => {
  attachments.value.splice(index, 1);
  tack.value.splice(index, 1);
};

const openFileInput = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

defineExpose({
  openCreateTask
});
</script>

<template>
  <div>
    <ModalResponsable ref="modalResponsable" />
    <ModalCustomRecurrence ref="modalCustomRecurrence" @save-recurrence="handleSaveRecurrence" />
    <RequiredFill ref="RequiredFillRef" />

    <ModalMain ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <div class="d-flex align-items-center gap-2">
            <h5 class="m-0 font-docs font-weight-bold mr-4" style="font-size: 20px; color: #212529;">
              Cadastrar
            </h5>
            <div class="activity-type-toggle d-flex">
              <button
                type="button"
                :class="['activity-type-btn', activityType === 'task' ? 'activity-type-btn--active' : '']"
                @click="activityType = 'task'"
              >
                <i class="fa-solid fa-list-check mr-1"></i> Tarefa
              </button>
              <button
                type="button"
                :class="['activity-type-btn', activityType === 'event' ? 'activity-type-btn--active' : '']"
                @click="activityType = 'event'"
              >
                <i class="fa-regular fa-calendar mr-1"></i> Evento
              </button>
            </div>
          </div>

          <button
            id="close"
            type="button"
            class="close"
            @click="viewDocument.closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <template #body>
        <div class="modal-form font-docs">
          <template v-if="activityType === 'task'">
            <div class="row g-2 mb-3">
              <div class="col-12 col-md-3">
                <label class="label-custom">Data <span class="text-danger">*</span></label>
                <input type="date" class="input-custom" v-model="DateStart" />
              </div>

              <div class="col-12 col-md-3">
                <label class="label-custom">Horário</label>
                <input type="time" class="input-custom" v-model="hour" />
              </div>

              <div class="col-12 col-md-3">
                <label class="label-custom">Situação <span class="text-danger">*</span></label>
                <Dropdown
                  v-model="status"
                  :options="statuses"
                  optionLabel="label"
                  placeholder="Selecione um status"
                  class="w-100 custom-dropdown"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="d-flex align-items-center">
                      <Tag
                        v-if="slotProps.value.label === 'À iniciar' || slotProps.value === '1' || slotProps.value.value === 1"
                        rounded
                        style="background-color: #E9ECEF; color: #6C757D; padding: 3px 12px;"
                      >
                        <span class="text-xs font-docs"><b>À iniciar</b></span>
                      </Tag>
                      <Tag
                        v-if="slotProps.value.label === 'Em andamento' || slotProps.value === '2' || slotProps.value.value === 2"
                        rounded
                        style="background-color: #CFF4FC; color: #087990; padding: 3px 12px;"
                      >
                        <span class="text-xs font-docs"><b>Em andamento</b></span>
                      </Tag>
                      <Tag
                        v-if="slotProps.value.label === 'Bloqueada' || slotProps.value.label === 'Bloqueado' || slotProps.value === '4' || slotProps.value.value === 4"
                        rounded
                        style="background-color: #F8D7DA; color: #842029; padding: 3px 12px;"
                      >
                        <span class="text-xs font-docs"><b>Bloqueada</b></span>
                      </Tag>
                      <Tag
                        v-if="slotProps.value.label === 'Concluída' || slotProps.value === '3' || slotProps.value.value === 3"
                        rounded
                        style="background-color: rgba(9, 167, 6, 0.1); color: rgb(9, 167, 6); padding: 3px 12px;"
                      >
                        <span class="text-xs font-docs"><b>Concluída</b></span>
                      </Tag>
                    </div>
                  </template>
                  <template #option="{ option }">
                    <div class="d-flex align-items-center py-1">
                      <Tag v-if="option.label === 'À iniciar'" rounded style="background-color: #E9ECEF; color: #6C757D; padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                      </Tag>
                      <Tag v-if="option.label === 'Em andamento'" rounded style="background-color: #CFF4FC; color: #087990; padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                      </Tag>
                      <Tag v-if="option.label === 'Bloqueada' || option.label === 'Bloqueado'" rounded style="background-color: #F8D7DA; color: #842029; padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                      </Tag>
                      <Tag v-if="option.label === 'Concluída'" rounded style="background-color: rgba(9, 167, 6, 0.1); color: rgb(9, 167, 6); padding: 3px 12px;">
                        <span class="text-xs font-docs"><b>{{ option.label }}</b></span>
                      </Tag>
                    </div>
                  </template>
                </Dropdown>
              </div>

              <div class="col-12 col-md-3">
                <label class="label-custom">Prioridade</label>
                <Dropdown
                  v-model="priority"
                  :options="priorityLabels"
                  optionLabel="label"
                  placeholder="Selecione uma prioridade"
                  class="w-100 custom-dropdown"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="d-flex align-items-center" style="height: 100%;">

                      <div v-if="slotProps.value === '1' || slotProps.value?.value === 1 || slotProps.value?.label === 'Baixa'" class="d-flex align-items-center">
                        <i class="fa-solid fa-angle-up mr-2" style="color: #0D6EFD; font-size: 14px; line-height: 1;"></i>
                        <span style="font-size: 13px;">Baixa</span>
                      </div>

                      <div v-if="slotProps.value === '2' || slotProps.value?.value === 2 || slotProps.value?.label === 'Média'" class="d-flex align-items-center">
                        <div class="d-flex flex-column align-items-center justify-content-center mr-2" style="color: #FFC107; line-height: 0.5;">
                          <i class="fa-solid fa-angle-up" style="font-size: 11px; margin-bottom: -4px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 11px;"></i>
                        </div>
                        <span style="font-size: 13px;">Média</span>
                      </div>

                      <div v-if="slotProps.value === '3' || slotProps.value?.value === 3 || slotProps.value?.label === 'Alta'" class="d-flex align-items-center">
                        <div class="d-flex flex-column align-items-center justify-content-center mr-2" style="color: #F76659; line-height: 0.5;">
                          <i class="fa-solid fa-angle-up" style="font-size: 11px; margin-bottom: -4px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 11px; margin-bottom: -4px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 11px;"></i>
                        </div>
                        <span style="font-size: 13px;">Alta</span>
                      </div>
                    </div>
                  </template>

                  <template #option="{ option }">
                    <div class="d-flex align-items-center py-1">
                      <div v-if="option.label === 'Baixa'" class="d-flex align-items-center">
                        <i class="fa-solid fa-angle-up mr-2" style="color: #0D6EFD; font-size: 14px; line-height: 1;"></i>
                        <span style="font-size: 13px;">{{ option.label }}</span>
                      </div>

                      <div v-if="option.label === 'Média'" class="d-flex align-items-center">
                        <div class="d-flex flex-column align-items-center justify-content-center mr-2" style="color: #FFC107; line-height: 0.5;">
                          <i class="fa-solid fa-angle-up" style="font-size: 11px; margin-bottom: -4px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 11px;"></i>
                        </div>
                        <span style="font-size: 13px;">{{ option.label }}</span>
                      </div>

                      <div v-if="option.label === 'Alta'" class="d-flex align-items-center">
                        <div class="d-flex flex-column align-items-center justify-content-center mr-2" style="color: #F76659; line-height: 0.5;">
                          <i class="fa-solid fa-angle-up" style="font-size: 11px; margin-bottom: -4px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 11px; margin-bottom: -4px;"></i>
                          <i class="fa-solid fa-angle-up" style="font-size: 11px;"></i>
                        </div>
                        <span style="font-size: 13px;">{{ option.label }}</span>
                      </div>
                    </div>
                  </template>
                </Dropdown>
              </div>
            </div>

            <div class="mb-3">
              <label class="label-custom">Nome <span class="text-danger">*</span></label>
              <input
                type="text"
                class="input-custom"
                v-model="NameTask"
                placeholder="Nome da tarefa"
              />
            </div>

            <div class="mb-3">
              <label class="label-custom">Descrição</label>
              <textarea
                v-model="DescriptionTask"
                class="textarea-custom"
                placeholder="Descrição da tarefa"
                rows="3"
              ></textarea>
            </div>

            <div class="mb-3">
              <button
                type="button"
                class="btn-text-action"
                @click="addNewChecklist"
              >
                + Adicionar lista
              </button>
              <ToDoList ref="todolist" :hideAddButton="true" />
            </div>

            <div class="row g-3 mb-3 align-items-center">
              <div class="col-12 col-md-7">
                <label class="label-custom">Convidados</label>
                <MultiSelectPrime
                  display="chip"
                  v-model="Users"
                  :options="Store.users"
                  filter
                  optionLabel="name"
                  placeholder="Busque por nome, e-mail ou setor..."
                  :maxSelectedLabels="2"
                  :showToggleAll="false"
                  class="w-100 custom-multiselect"
                >
                  <template #option="slotProps">
                    <div class="d-flex align-items-center py-1">
                      <img
                        :alt="slotProps.option.name"
                        :src="$userAvatar(slotProps.option.path_image)"
                        class="mr-2"
                        style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;"
                      />
                      <div class="d-flex flex-column">
                        <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.option.name }}</span>
                        <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.option.email }}</span>
                      </div>
                    </div>
                  </template>
                </MultiSelectPrime>
              </div>

              <div class="col-12 col-md-5">
                <label class="label-custom">Responsável</label>
                <div class="responsable-box d-flex align-items-center justify-content-between p-2">
                  <div class="d-flex align-items-center text-truncate">
                    <img
                      :src="$userAvatar(Store.responsableTask?.path_image)"
                      alt="Avatar"
                      class="responsable-avatar mr-2"
                    />
                    <div class="d-flex flex-column text-truncate">
                      <span class="responsable-name text-truncate">
                        <b>{{ Store.responsableTask?.name }}</b>
                      </span>
                      <span class="responsable-email text-truncate">
                        {{ Store.responsableTask?.email }}
                      </span>
                    </div>
                  </div>
                  <i
                    class="fa-solid fa-pen edit-responsable-icon ml-2"
                    @click="editResponsable"
                    title="Editar responsável"
                  ></i>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <button
                type="button"
                class="btn-outline-attachment"
                @click="openFileInput"
              >
                <i class="fa-solid fa-arrow-up-from-bracket mr-2"></i>
                Adicionar arquivo
              </button>
              <input
                type="file"
                ref="fileInput"
                @change="addAttachment"
                accept=".doc,.docx,.odt,.pdf,.png,.jpg,.svg"
                style="display: none"
                multiple
              />

              <div v-if="attachments.length > 0" class="attachments-list mt-2">
                <div
                  v-for="(attachment, index) in attachments"
                  :key="index"
                  class="attachment-item d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center text-truncate">
                    <i class="fa-regular fa-file mr-2 text-muted"></i>
                    <span class="text-truncate">{{ attachment.name }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn-icon-remove"
                    @click="removeAttachment(index)"
                    title="Remover anexo"
                  >
                    <i class="fa-regular fa-trash-can"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="comments-section pt-3">
              <label class="label-custom mb-2">Comentários</label>
              <div class="d-flex align-items-center">
                <img
                  :src="$userAvatar(Store.user?.path_image)"
                  alt="Avatar"
                  class="comment-user-avatar mr-2"
                />
                <div class="flex-grow-1 position-relative d-flex align-items-center">
                  <input
                    type="text"
                    v-model="commentText"
                    class="input-custom pr-5"
                    placeholder="Escrever um comentário"
                    @keyup.enter="submitComment"
                  />
                  <button
                    type="button"
                    class="btn-send-comment"
                    @click="submitComment"
                    title="Enviar comentário"
                  >
                    <i class="fa-solid fa-paper-plane"></i>
                  </button>
                </div>
              </div>

              <div v-if="commentsList.length > 0" class="comments-list mt-2">
                <div
                  v-for="(c, cIdx) in commentsList"
                  :key="cIdx"
                  class="comment-item d-flex align-items-start p-2 mb-1"
                >
                  <img
                    :src="$userAvatar(c.user?.path_image)"
                    class="mr-2"
                    style="width: 26px; height: 26px; border-radius: 50%; object-fit: cover;"
                  />
                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-center">
                      <strong style="font-size: 13px;">{{ c.user?.name || 'Você' }}</strong>
                      <small class="text-muted" style="font-size: 11px;">Agora</small>
                    </div>
                    <p class="m-0 text-secondary" style="font-size: 13px;">{{ c.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <template v-if="activityType === 'event'">
            <div class="row g-2 mb-3">
              <div class="col-12 col-md-4">
                <label class="label-custom">Data <span class="text-danger">*</span></label>
                <input type="date" class="input-custom" v-model="DateStart" />
              </div>

              <div class="col-12 col-md-4">
                <label class="label-custom">Hora</label>
                <input
                  type="time"
                  class="input-custom"
                  v-model="hour"
                  :disabled="allDay"
                />
              </div>

              <div class="col-12 col-md-4">
                <label class="label-custom">Local</label>
                <div class="input-with-icon">
                  <input
                    type="text"
                    class="input-custom pr-4"
                    v-model="place"
                    placeholder="Meet, Sala de reunião..."
                  />
                  <i class="fa-solid fa-location-dot input-icon"></i>
                </div>
              </div>
            </div>

            <div class="row g-2 mb-3 align-items-center">
              <div class="col-12 col-md-4 d-flex align-items-center">
                <div class="form-check d-flex align-items-center m-0">
                  <input
                    type="checkbox"
                    id="allDayCheckbox"
                    class="form-check-input recurrence-checkbox"
                    v-model="allDay"
                  />
                  <label for="allDayCheckbox" class="form-check-label ml-2" style="cursor: pointer; font-size: 14px;">
                    Dia inteiro
                  </label>
                </div>
              </div>

              <div class="col-12 col-md-8">
                <select
                  class="input-custom select-custom"
                  v-model="frequency_type"
                  @change="onRecurrenceChange"
                >
                  <option value="1">Não se repete</option>
                  <option value="2">Todos os dias</option>
                  <option value="3">Semanal: cada {{ week }}</option>
                  <option value="4">Mensal: dia {{ day }}</option>
                  <option value="5">Anual: em {{ month }} {{ day }}</option>
                  <option value="6">Todos os dias da semana (segunda a sexta-feira)</option>
                  <option value="custom">Personalizar...</option>
                </select>
              </div>
            </div>

            <div class="mb-3">
              <label class="label-custom">Nome <span class="text-danger">*</span></label>
              <input
                type="text"
                class="input-custom"
                v-model="NameTask"
                placeholder="Nome do evento"
              />
            </div>

            <div class="mb-3">
              <div class="d-flex justify-content-between align-items-center">
                <label class="label-custom">Link de acesso à vídeo conferência <span class="text-danger">*</span></label>
                <button
                  type="button"
                  class="btn-meet-helper"
                  @click="addMeetLink"
                  title="Gerar link do Google Meet"
                >
                  <i class="fa-solid fa-video mr-1"></i> Google Meet
                </button>
              </div>
              <input
                type="text"
                class="input-custom"
                v-model="placeLink"
                placeholder="https://meet.google.com/"
              />
            </div>

            <div class="mb-3">
              <label class="label-custom">Descrição</label>
              <textarea
                v-model="DescriptionTask"
                class="textarea-custom"
                placeholder="Descrição do evento"
                rows="3"
              ></textarea>
            </div>

            <div class="mb-3">
              <button
                type="button"
                class="btn-text-action"
                @click="addNewChecklist"
              >
                + Adicionar lista
              </button>
              <ToDoList ref="todolist" :hideAddButton="true" />
            </div>

            <div class="mb-3">
              <label class="label-custom">Convidados</label>
              <MultiSelectPrime
                display="chip"
                v-model="Users"
                :options="Store.users"
                filter
                optionLabel="name"
                placeholder="Busque por nome, e-mail ou setor..."
                :maxSelectedLabels="3"
                :showToggleAll="false"
                class="w-100 custom-multiselect"
              >
                <template #option="slotProps">
                  <div class="d-flex align-items-center py-1">
                    <img
                      :alt="slotProps.option.name"
                      :src="$userAvatar(slotProps.option.path_image)"
                      class="mr-2"
                      style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover;"
                    />
                    <div class="d-flex flex-column">
                      <span style="font-size: 13px; font-weight: 600; line-height: 1.2;">{{ slotProps.option.name }}</span>
                      <span style="font-size: 11px; color: #6c757d; line-height: 1.2;">{{ slotProps.option.email }}</span>
                    </div>
                  </div>
                </template>
              </MultiSelectPrime>
            </div>

            <div class="mb-3">
              <button
                type="button"
                class="btn-outline-attachment"
                @click="openFileInput"
              >
                <i class="fa-solid fa-arrow-up-from-bracket mr-2"></i>
                Adicionar arquivo
              </button>
              <input
                type="file"
                ref="fileInput"
                @change="addAttachment"
                accept=".doc,.docx,.odt,.pdf,.png,.jpg,.svg"
                style="display: none"
                multiple
              />

              <div v-if="attachments.length > 0" class="attachments-list mt-2">
                <div
                  v-for="(attachment, index) in attachments"
                  :key="index"
                  class="attachment-item d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex align-items-center text-truncate">
                    <i class="fa-regular fa-file mr-2 text-muted"></i>
                    <span class="text-truncate">{{ attachment.name }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn-icon-remove"
                    @click="removeAttachment(index)"
                    title="Remover anexo"
                  >
                    <i class="fa-regular fa-trash-can"></i>
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button
            type="button"
            class="btn btn-outline-action font-docs"
            @click="viewDocument.closeModal()"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-solid-action font-docs"
            @click="CreateTask"
            :disabled="loading"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            Cadastrar
          </button>
        </div>
      </template>
    </ModalMain>
  </div>
</template>

<style scoped>
.font-docs {
  font-family: inherit;
}

.activity-type-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.activity-type-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #F1860B;
  background-color: #ffffff;
  color: #F1860B;
  cursor: pointer;
  line-height: 1;
  transition: all 0.2s ease;
}

.activity-type-btn:hover {
  background-color: rgba(241, 134, 11, 0.08);
}

.activity-type-btn--active {
  background-color: #F1860B !important;
  color: #ffffff !important;
  border-color: #F1860B !important;
}

.label-custom {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 4px;
  display: block;
}

.input-custom {
  width: 100%;
  height: 40px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  background-color: #ffffff;
  color: #212529;
  outline: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.input-custom:focus {
  border-color: #F1860B;
  box-shadow: 0 0 0 0.15rem rgba(241, 134, 11, 0.2);
}

.textarea-custom {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  background-color: #ffffff;
  color: #212529;
  outline: none;
  resize: vertical;
  min-height: 70px;
  transition: border-color 0.15s ease-in-out;
}

.textarea-custom:focus {
  border-color: #F1860B;
  box-shadow: 0 0 0 0.15rem rgba(241, 134, 11, 0.2);
}

.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  right: 12px;
  color: #6c757d;
  font-size: 14px;
  pointer-events: none;
}

.btn-meet-helper {
  background: transparent;
  border: none;
  color: #F1860B;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.btn-meet-helper:hover {
  color: #d97405;
}

.btn-text-action {
  background: transparent;
  border: none;
  color: #F1860B;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
}

.btn-text-action:hover {
  color: #d97405;
  text-decoration: underline;
}

.responsable-box {
  border: 1px solid #ced4da;
  border-radius: 6px;
  min-height: 40px;
  background-color: #ffffff;
}

.responsable-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.responsable-name {
  font-size: 13px;
  color: #212529;
}

.responsable-email {
  font-size: 11px;
  color: #6c757d;
}

.edit-responsable-icon {
  color: #F1860B;
  cursor: pointer;
  font-size: 15px;
  padding: 4px;
  transition: color 0.15s;
}

.edit-responsable-icon:hover {
  color: #d97405;
}

.btn-outline-attachment {
  border: 1px solid #F1860B;
  color: #F1860B;
  background: transparent;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s;
  cursor: pointer;
}

.btn-outline-attachment:hover {
  background-color: rgba(241, 134, 11, 0.08);
}

.attachment-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
}

.btn-icon-remove {
  background: transparent;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 2px 6px;
}

.comments-section {
  border-top: 1px solid #e9ecef;
}

.comment-user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}

.btn-send-comment {
  position: absolute;
  right: 6px;
  background-color: #F1860B;
  color: #ffffff;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s;
}

.btn-send-comment:hover {
  background-color: #d97405;
}

.comment-item {
  background-color: #f8f9fa;
  border-radius: 6px;
}

.btn-outline-action {
  color: #F1860B;
  border: 1px solid #F1860B;
  background: transparent;
  font-weight: 600;
  padding: 6px 18px;
  border-radius: 6px;
  transition: all 0.2s;
}

.btn-outline-action:hover {
  background-color: rgba(241, 134, 11, 0.08);
}

.btn-solid-action {
  background-color: #F1860B;
  color: #ffffff;
  border: 1px solid #F1860B;
  font-weight: 600;
  padding: 6px 22px;
  border-radius: 6px;
  transition: all 0.2s;
}

.btn-solid-action:hover {
  background-color: #d97405;
  border-color: #d97405;
}

:deep(.custom-dropdown.p-dropdown) {
  height: 40px !important;
  border-radius: 6px !important;
  border-color: #ced4da !important;
  align-items: center;
}

:deep(.custom-dropdown.p-dropdown:focus),
:deep(.custom-dropdown.p-dropdown.p-focus) {
  border-color: #F1860B !important;
  box-shadow: 0 0 0 0.15rem rgba(241, 134, 11, 0.2) !important;
}

:deep(.custom-multiselect.p-multiselect) {
  min-height: 40px !important;
  border-radius: 6px !important;
  border-color: #ced4da !important;
  align-items: center;
}

:deep(.custom-multiselect.p-multiselect:focus),
:deep(.custom-multiselect.p-multiselect.p-focus) {
  border-color: #F1860B !important;
  box-shadow: 0 0 0 0.15rem rgba(241, 134, 11, 0.2) !important;
}
</style>